/*
 * File: /src/services/assetsServices.js
 * Created Date: Sunday July 5th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 5th July 2020 11:02:47 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_ASSETS_PATH } from '../constants';

export default {
  fetchAssets(afterId = null, limit = 100, filters = [], sort, assetType) {
    let params = {
      limit: limit,
    };

    if (afterId) {
      params['afterId'] = afterId;
    }
    
    if (sort) {
      params['sort'] = sort;
    }

    if (filters && filters.length > 0) {
      params['filter'] = filters;
    }

    if (assetType) {
      params['assetType'] = assetType;
    }

    return authedAxios.get(AD_BASE_ASSETS_PATH, { params });
  },

  fetchAsset(assetId) {
    return authedAxios.get(AD_BASE_ASSETS_PATH + assetId);
  },

  deleteAsset(assetId) {
    return authedAxios.delete(AD_BASE_ASSETS_PATH + assetId);
  },
};
